// extracted by mini-css-extract-plugin
module.exports = {"slider":"slider_slider__3TXi0","sliderSteps":"slider_sliderSteps__3mN36","sliderInput":"slider_sliderInput__2kkEm","steps":"slider_steps__1XsKb","step":"slider_step__1g0c9"};